type DataLayerObject = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: DataLayerObject[];
  }
}

interface GtmConfig {
  id: string;
  enabled?: boolean;
}

let config: GtmConfig | null = null;
let scriptLoaded = false;

export function initGtm(opts: GtmConfig): void {
  config = opts;
  if (!opts.id || opts.enabled === false) return;
  window.dataLayer = window.dataLayer ?? [];
  if (scriptLoaded) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${opts.id}`;
  const first = document.getElementsByTagName('script')[0];
  first?.parentNode?.insertBefore(script, first);
  scriptLoaded = true;
}

export function pushEvent(event: DataLayerObject): void {
  if (!config?.id || config.enabled === false) return;
  window.dataLayer?.push(event);
}

export function pushPageView(pageName: string, additionalData?: DataLayerObject): void {
  pushEvent({ event: 'page', pageName, ...additionalData });
}

export function pushTag(item: DataLayerObject): void {
  pushEvent(item);
}
